import React, { useEffect, useState } from 'react'
import { CAvatar, CCol, CForm, CFormInput, CFormLabel, CFormSelect, CFormTextarea, CRow } from '@coreui/react'
import { Icon } from '@iconify/react'
import { Button } from '@mui/material'
import { Toast } from 'primereact/toast'
import { useAuth } from '../contexts/AuthContext'
import { useCompanySetting } from '../contexts/CompanySettingContext'
import { useNavigate } from 'react-router-dom'
import { settingNav } from '../components/NavigationPath';
import Layout2 from '../components/Layout2'
import CInput from '../components/CInput';

const countriesOptions = [
    "United States",
    "Canada",
    "United Kingdom",
    "Germany",
    "France",
    "Japan",
    "Australia",
    "Brazil",
    "India",
    "China",
    "Russia",
    "South Africa",
    "Mexico",
    "Argentina",
    "Italy",
    "Spain",
    "Nigeria",
    "Egypt",
    "South Korea",
    "Turkey"
];

const currencyOptions = [
    "USD",
    "EUR",
    "INR",
];

const CreateCompanySetting = () => {
    const { getSingleCompany, updateCompany } = useCompanySetting()
    const { toast } = useAuth();

    const navigate = useNavigate();

    const [validated, setValidated] = useState(false);
    const [companyDetail, setCompanyDetail] = useState({
        name: "",
        display_name: "",
        description: "",
        street_name: "",
        street_number: "",
        postal_code: "",
        city: "",
        country: "",
        telephone_number: "",
        fax_number: "",
        timezone: "",
        website: "",
        logo: "",
        currency: "USD"
    })

    const fetchSingleCompany = async () => {
        try {
            const company = await getSingleCompany();
            if (typeof company !== 'undefined') {
                setCompanyDetail(company);
            }
        } catch (error) {
            console.error('Error fetching single company', error);
        }
    };

    useEffect(() => {
        fetchSingleCompany()
    }, [])

    const handlePhoto = async (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setCompanyDetail({ ...companyDetail, logo: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (companyDetail?.id) {
                    const data = await updateCompany(companyDetail)
                    if (!data.error) {
                        navigate('/admin/settings/company')
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    return (
        <Layout2 items={settingNav.items} navTitle={settingNav.header}>
            <Toast ref={toast} />
            <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                <div className="d-flex flex-column w-100">
                    <div className='d-flex flex-row px-4 py-2 w-100 border-bottom'>
                        <div className='w-100'>
                            <h4>Company Setting</h4>
                        </div>
                        <div className='d-flex justify-content-end w-100'>
                            <div className='align-self-end header_btn_container'>
                                <Button variant="outlined" color='success' type="submit">SAVE</Button>
                            </div>
                        </div>
                    </div>
                    <div className='px-4 py-2'>
                        <div className='border-bottom mb-5 mt-5'>
                            <div className='d-flex mb-5 px-4'>
                                <div className='w-50'>
                                    <div className='mb-3 setting-title'>GENERAL INFO</div>
                                    <div>The display name appears on printed receipts.</div>
                                </div>
                                <div className='w-75'>
                                    <CRow className='mb-4'>
                                        <CCol lg={6}>
                                            <CInput
                                                label={'Company Name'}
                                                required={true}
                                                value={companyDetail.name}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, name: value })}
                                                errorMessage='Name is required.'
                                            />
                                        </CCol>
                                        <CCol lg={6}>
                                            <CInput
                                                label={'Display Name'}
                                                required={true}
                                                value={companyDetail.display_name}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, display_name: value })}
                                                errorMessage='Display name is required.'
                                            />
                                        </CCol>
                                    </CRow>
                                    <CFormTextarea
                                        label='Description of your company'
                                        value={companyDetail.description}
                                        onChange={(e) => setCompanyDetail({ ...companyDetail, description: e.target.value })}
                                        rows={5} />
                                </div>
                            </div>
                        </div>
                        <div className='border-bottom'>
                            <div className='d-flex mb-5 px-4'>
                                <div className='w-50'>
                                    <div className='mb-3 setting-title'>ADDRESS</div>
                                    <div>Warning: Editing the conutry will automatically apply default setting for the new conutry. Your current settings will be lost.</div>
                                </div>
                                <div className='w-75'>
                                    <CRow className='mb-4'>
                                        <CCol lg={9}>
                                            <CInput
                                                label={'Street Name'}
                                                required={true}
                                                value={companyDetail.street_name}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, street_name: value })}
                                                errorMessage='Street name is required.'
                                            />
                                        </CCol>
                                        <CCol lg={3}>
                                            <CInput
                                                label={'Street Number'}
                                                required={true}
                                                value={companyDetail.street_number}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, street_number: value })}
                                                errorMessage='Street number is required.'
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol>
                                            <CInput
                                                label={'Postal code'}
                                                required={true}
                                                value={companyDetail.postal_code}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, postal_code: value })}
                                                errorMessage='Postal code is required.'
                                            />
                                        </CCol>
                                        <CCol>
                                            <CInput
                                                label={'City'}
                                                required={true}
                                                value={companyDetail.city}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, city: value })}
                                                errorMessage='City is required.'
                                            />
                                        </CCol>
                                        <CCol>
                                            <CFormSelect
                                                label="Country"
                                                options={countriesOptions}
                                                value={companyDetail.country}
                                                onChange={(e) => setCompanyDetail({ ...companyDetail, country: e.target.value })} />
                                        </CCol>
                                    </CRow>
                                </div>
                            </div>
                        </div>
                        <div className='mt-5 border-bottom'>
                            <div className='d-flex mb-5 px-4'>
                                <div className='w-50'>
                                    <div className='mb-3 setting-title'>CONTACT DETAILS</div>
                                    {/* <div>Warning: Editing the conutry will automatically apply default setting for the new conutry. Your current settings will be lost.</div> */}
                                </div>
                                <div className='w-75'>
                                    <CRow className='mb-4'>
                                        <CCol lg={6}>
                                            <div>
                                                <CFormLabel>Telephone number <span className="text-danger">*</span></CFormLabel>
                                                <CFormInput
                                                    type={'text'}
                                                    maxlength="13"
                                                    minlength="10"
                                                    value={companyDetail.telephone_number}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        const numericValue = inputValue.replace(/[^\d+]/g, '');
                                                        setCompanyDetail({ ...companyDetail, telephone_number: numericValue });
                                                    }}
                                                    required
                                                    feedbackInvalid='Enter valid telephone number'
                                                />
                                            </div>
                                        </CCol>
                                        <CCol lg={6}>
                                            <CInput
                                                label={'Fax number'}
                                                value={companyDetail.fax_number}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, fax_number: value })}
                                            />
                                        </CCol>
                                    </CRow>
                                </div>
                            </div>
                        </div>
                        <div className='mt-5'>
                            <div className='d-flex mb-5 px-4'>
                                <div className='w-50'>
                                    <div className='mb-3 setting-title'>OTHER DETAILS</div>
                                    {/* <div>Warning: Editing the conutry will automatically apply default setting for the new conutry. Your current settings will be lost.</div> */}
                                </div>
                                <div className='w-75'>
                                    <CRow className='mb-4'>
                                        <CCol>
                                            <CInput
                                                label={'Timezone'}
                                                value={companyDetail.timezone}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, timezone: value })}
                                            />
                                        </CCol>
                                        <CCol>
                                            <CInput
                                                label={'Website'}
                                                value={companyDetail.website}
                                                onChange={(value) => setCompanyDetail({ ...companyDetail, website: value })}
                                            />
                                        </CCol>
                                        <CCol>
                                            <CFormSelect
                                                label="Currency"
                                                options={currencyOptions}
                                                value={companyDetail.currency}
                                                onChange={(e) => setCompanyDetail({ ...companyDetail, currency: e.target.value })} />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol lg={6}>
                                            <CFormInput
                                                type='file'
                                                label="Logo"
                                                onChange={handlePhoto} />
                                        </CCol>
                                        <CCol lg={3} style={{ position: 'relative' }}>
                                            {
                                                companyDetail.logo ?
                                                    <CAvatar src={companyDetail.logo} color="primary" textColor="white" shape="rounded" className='company-logo' />
                                                    :
                                                    <CAvatar color="primary" textColor="white" shape="rounded" className='company-text-logo'>LOGO</CAvatar>
                                            }
                                            {
                                                companyDetail.logo &&
                                                <Icon
                                                    icon="mdi:close"
                                                    className='close-btn'
                                                    height={15}
                                                    width={15}
                                                    onClick={() => setCompanyDetail({ ...companyDetail, logo: '' })}
                                                />
                                            }
                                        </CCol>
                                    </CRow>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CForm>
        </Layout2>
    )
}

export default CreateCompanySetting